document.addEventListener("DOMContentLoaded", async () => {
  const $ = (s) => document.querySelector(s);
  const $$ = (s) => document.querySelectorAll(s);

  const dom = {
    categories: $$(".selection-tool .categories .category"),
    appTypeSelect: $(".selection-tool .dropdowns .application-type"),
    filmTypeSelect: $(".selection-tool .dropdowns .film-type"),
    resetBtn: $(".selection-tool  .reset-button"),
    footerMsg: $(".selection-tool .footer .message"),
    tableContainer: $(".selection-tool .table-results-container")
  };

  const state = {
    selectedCategory: "interior",
    selectedApplication: null,
    selectedFilmType: null,
    vinylData: {}
  };

  let PRODUCT_LINKS = {};
  let PRODUCT_LABELS = {};

  const fetchData = () => {
    try {
      const scriptTag = document.getElementById("vinyl-film-data");
      const json = JSON.parse(scriptTag.textContent || scriptTag.innerText);
      console.log('json--',json);
      state.vinylData = json;
      PRODUCT_LINKS = json._productLinks || {};
      PRODUCT_LABELS = json._productLabels || {};
      updateApplications();
    } catch (err) {
      console.error("Failed to parse vinyl data from script tag:", err);
    }
  };

  function clearDropdown(select) {
    select.innerHTML = "";
  }

  function createOption(text, disabled = false, selected = false) {
    const opt = document.createElement("option");
    opt.textContent = text;
    opt.disabled = disabled;
    opt.selected = selected;
    return opt;
  }

  function show(el) {
    el.classList.remove("hidden");
  }

  function hide(el) {
    el.classList.add("hidden");
  }

  function showMessage(msg, danger = false) {
    dom.footerMsg.textContent = msg;
    dom.footerMsg.classList.toggle("danger", danger);
  }

  function updateApplications() {
    const apps = Object.keys(state.vinylData[state.selectedCategory] || {});
    clearDropdown(dom.appTypeSelect);
    dom.appTypeSelect.appendChild(createOption("Enter an application", true, true));
    apps.forEach(app => {
      dom.appTypeSelect.appendChild(createOption(app));
    });
    clearDropdown(dom.filmTypeSelect);
    dom.filmTypeSelect.appendChild(createOption("Enter a film type", true, true));
    hide(dom.tableContainer);
    hide(dom.resetBtn);
    showMessage("Select an application and film type above to get your product selections!");
  }

  function updateFilms() {
    const filmData = state.vinylData[state.selectedCategory]?.[state.selectedApplication] || {};
    const filmTypes = Object.keys(filmData);
    clearDropdown(dom.filmTypeSelect);
    dom.filmTypeSelect.appendChild(createOption("Enter a film type", true, true));
    filmTypes.forEach(type => {
      dom.filmTypeSelect.appendChild(createOption(type));
    });
    hide(dom.tableContainer);
    hide(dom.resetBtn);
  }

function renderResults() {
  const filmSet = state.vinylData[state.selectedCategory]?.[state.selectedApplication]?.[state.selectedFilmType];
  if (!filmSet) {
    showMessage("Sorry, no results for these selections.", true);
    hide(dom.tableContainer);
    return;
  }

  const columns = {
    GOOD: [],
    BETTER: [],
    BEST: []
  };

  let extraMessage = "";

  Object.keys(filmSet).forEach(quality => {
    if (quality === "Message") {
      extraMessage = filmSet[quality];
      return;
    }

    const upperQuality = quality.toUpperCase();
    const films = filmSet[quality];
    films.forEach(film => {
      const cleanFilm = film.replace(/\s*\(.*?\)/g, "");
      const link = PRODUCT_LINKS[cleanFilm] || "#";
      const label = PRODUCT_LABELS?.[cleanFilm] ? ` (${PRODUCT_LABELS[cleanFilm]})` : "";
      const pillHTML = `<div class="pill"><a href="${link}">${cleanFilm}${label}</a></div>`;

      if (!columns[upperQuality]) columns[upperQuality] = [];
      columns[upperQuality].push(pillHTML);
    });
  });

  let html = `<div class="table-result">`;

  // Substrate Examples block
  if (extraMessage) {
    const examples = extraMessage.split("\\").map(e => `<p class="example">${e.trim()}</p>`).join("");
    html += `
      <div class="substrate-examples-container">
        <div class="title">Substrate Examples</div>
        <div class="substrate-examples">
          ${examples}
        </div>
      </div>`;
  }

  html += `<div class="quality-and-collection-grid">`;

  if (columns.GOOD.length) {
    html += `
      <div class="quality good">
        <div class="quality-title">GOOD</div>
        ${columns.GOOD.join("")}
      </div>`;
  }

  if (columns.BETTER.length) {
    html += `
      <div class="quality better">
        <div class="quality-title">BETTER</div>
        ${columns.BETTER.join("")}
      </div>`;
  }

  if (columns.BEST.length) {
    html += `
      <div class="quality best">
        <div class="quality-title">BEST</div>
        ${columns.BEST.join("")}
      </div>`;
  }

  html += `</div></div>`;

  dom.tableContainer.innerHTML = html;
  show(dom.tableContainer);
  show(dom.resetBtn);
  showMessage("");
}
  
  function resetAll() {
    state.selectedApplication = null;
    state.selectedFilmType = null;
    dom.appTypeSelect.selectedIndex = 0;
    clearDropdown(dom.filmTypeSelect);
    dom.filmTypeSelect.appendChild(createOption("Enter a film type", true, true));
    hide(dom.resetBtn);
    showMessage("Select an application and film type above to get your product selections!");
    hide(dom.tableContainer);
  }

  dom.categories.forEach(cat => {
    cat.addEventListener("click", () => {
      dom.categories.forEach(c => c.classList.remove("active"));
      cat.classList.add("active");
      const title = cat.querySelector(".title")?.textContent?.toLowerCase();
      state.selectedCategory = title;
      state.selectedApplication = null;
      state.selectedFilmType = null;
      updateApplications();
    });
  });

  dom.appTypeSelect.addEventListener("change", () => {
    state.selectedApplication = dom.appTypeSelect.value;
    state.selectedFilmType = null;
    updateFilms();
  });

  dom.filmTypeSelect.addEventListener("change", () => {
    state.selectedFilmType = dom.filmTypeSelect.value;
    renderResults();
  });

  dom.resetBtn.addEventListener("click", resetAll);

  fetchData();
});